import {useState} from 'react';
import {I18n} from 'aws-amplify/utils';
import {FlexiAddButton} from '@flexinet/ui-components';

import {ConnectProviderDrawer} from '../drawers/ConnectProviderDrawer';

// FNP-1248 — the Connect button.
//
// ⚠️ ALWAYS RENDERED, unlike the zones module's Add button.
//
// The zones Add button hides itself when no connection can create a zone,
// because it depends on a capability the tenant may not have. This one depends
// on nothing: connecting a provider is the FIRST thing a tenant does, and the
// module exists precisely because there was no way to do it. A button that
// hid itself when the tenant had no connections would hide exactly when it is
// needed most.
//
// ⚠️ USES THE SHARED FlexiAddButton, not a local Button. A private add button
// that also exists in @flexinet/ui-components is drift, not an override.

export const ConnectProviderButton = () => {

    const [drawerOpened, setDrawerOpened] = useState(false);

    if (drawerOpened) {
        return (
            <ConnectProviderDrawer
                opened={drawerOpened}
                onClose={() => setDrawerOpened(false)}
            />
        );
    }

    return (
        <FlexiAddButton onClick={() => setDrawerOpened(true)}>
            {I18n.get('Connect Provider')}
        </FlexiAddButton>
    );
};
